import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { SpinnerComponent } from '../components/shared/spinner/spinner.component';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  dialogRefCargando: any;
  constructor(private dialog: NgbModal, private utilsService: UtilsService) { }

  mostrarModalCargando() {
    this.dialogRefCargando = this.mostrarModal(SpinnerComponent, 'lg', null, 'spinner-dialog-container', true);
  }

  cerrarModalCargando() {
    this.dialogRefCargando.close();
  }

  mostrarModal(component: any, size: string, data?: any, cssClass?: string, scrollable?: boolean): NgbModalRef {
    const dialogConfig: NgbModalOptions = {
      backdrop: 'static',
      size: size,
      centered: true
    };
    if (this.utilsService.validarString(cssClass))
      dialogConfig.windowClass = cssClass;
    else
      dialogConfig.windowClass = 'animate__animated animate__fadeInDown';
    if (this.utilsService.validarObjeto(scrollable))
      dialogConfig.scrollable = scrollable;
    const modalRef = this.dialog.open(component, dialogConfig);
    if (this.utilsService.validarObjeto(data))
      modalRef.componentInstance.data = data;
    return modalRef;
  }
}
